module.exports = __webpack_public_path__ + "static/media/store_outlet_shop.66151bb3.svg";